const LOCALES = { en: "en-US", fr: "fr-FR" };

const STYLES = {
	long: { year: "numeric", month: "long", day: "numeric" },
	month: { year: "numeric", month: "short" },
};

/**
 * A date in the visitor's language: 'long' -> "March 1, 2025" / "1 mars 2025",
 * 'month' -> "Mar 2025" / "mars 2025". Empty input gives ""; an unparseable
 * value is returned as text rather than "Invalid Date".
 */
export function formatDate(dateLike, lang, style = "long") {
	if (!dateLike) return "";
	const date = dateLike instanceof Date ? dateLike : new Date(dateLike);
	if (Number.isNaN(date.getTime())) return String(dateLike);
	return date.toLocaleDateString(LOCALES[lang] || LOCALES.en, STYLES[style] || STYLES.long);
}
